import { ReactComponent as Logo } from './Logo.svg'

export default Logo
